import React from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, transition } from 'theme';

export const ThreeStepCtaBlockStepBox = styled(
  ({ withLinks, url, large, ...props }) => {
    const onClick = () => {
      if (window && url) {
        window.location = url;
      }
    };

    return withLinks && !large ? (
      <Box
        onClick={url && onClick}
        padding={[24, null, 48]}
        width={1}
        height="100%"
        borderRadius={12}
        bg="white"
        boxShadow="0 0 20px rgba(0,0,0,0.1)"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    ) : (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Box width={1} {...props} />
    );
  }
)`
  ${(props) =>
    props.withLinks &&
    props.url &&
    !props.large &&
    `
      color: ${colors.greyishBrown};
      transition: all ${transition};
      cursor: pointer;
      a {
        color: inherit;
        text-decoration: none;
        transition: all ${transition};
        &:hover {
          text-decoration: none;
        }
      }
      &:hover {
        box-shadow: 0 0 6px rgba(0,0,0,0.2);
        a {
          color: ${colors.waterBlue};
        }
      }
    `}
`;
